import { Component, OnInit, ɵConsole } from '@angular/core';
import { NgbDateStruct, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../services/oms-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../../tools/src/lib/shared/shared.service';
import { ConstantsService } from '../services/constants.service';
import { FormGroup, FormControl, FormsModule, Validators } from '@angular/forms';
//import * as data from './data.';
import { ReportDetailsComponent } from '../modal-popups/report-details/report-details.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { configurton } from '../../assets/data/configuration';
//import { UploadReportComponent } from '../modal-popups/upload-report/upload-report.component';
import { TrackOrderComponent } from '../modal-popups/track-order/track-order.component';
import { DatePipe, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-orders-list',
  templateUrl: './orders-list.component.html',
  // imports: [NgbDatepickerModule, FormsModule, JsonPipe],
  styleUrls: ['./orders-list.component.scss']
})
export class OrdersListComponent implements OnInit {
  // dateCustomClasses: DatepickerDateCustomClasses[];
  model: NgbDateStruct;
  bsRangeValue: Date[];
  maxDate = new Date();
  currentDate = new Date();
  page = 1;
  pageSize = 20;
  collectionSize = 0;
  datacount = 0;
  curDate = new Date();
  from: string = "";
  year: String = '';
  month: String = '';
  day: String = '';
  searchForm: FormGroup;
  //verifyOtp:any;
  index = 0;
  selectedFromDate: any;
  selectedToDate: any;
  isOtpSend: boolean = false;
  orderDetailsRes = [];
  orderRequest = {};
  orderRequestBySearch = {};
  searchFormRequest = {};
  role: string = "";
  configuraionData;
  href = "";
  isSelected: boolean = true;
  totalRecords: Number = 0;
  isOrderListDataExist: boolean = false;
  diagnosticCenterList = [];
  orderStatusList: [];
  tenantOrgInfo: any;
  isTrack: Boolean = false;
  fromDate: any;
  endDate: any;
  isAllOrderSearch: Boolean = false;
  tenantsList: any;
  OrgList: any;
  organizationsOfTenants: any;
  dynamicSpan: number;
  hoveredDate: NgbDate | null = null;
  // fromDate: NgbDate | null | any;
  toDate: NgbDate | null;
  selectDate:any;
  formattedFromDate: any;
  formattedToDate: any;
  selectedStatusValue: any;
  selectedValue = 'scheduled_date'; 
  options = [
    { label: 'Scheduled Date', value: 'scheduled_date' },
    { label: 'Created Date', value: 'created_date' },
  ];
  businessOptions = [
    { label: 'Consultation', value: '1' },
    { label: 'Medicine', value: '2' },
    { label: 'Pathology', value: '3' },
    { label: 'Radiology', value: '4' },
  ];
  constructor(
    private omsServiceService: OmsServiceService,
    private _router: Router,
    private sharedService: SharedService,
    private _activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private modalService: NgbModal,
    private SpinnerService: NgxSpinnerService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
  ) {

    this.searchForm = new FormGroup({
      searchBy: new FormControl(),
      searchByValue: new FormControl(),
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
      diagnosticBranch: new FormControl(),
      status: new FormControl(),
      selectedTenant: new FormControl(),
      selectedOrg: new FormControl(),
      sortBy:new FormControl('scheduled_date'),
      businessId: new FormControl(),

    });
    // this.fromDate = calendar.getToday();
    // this.toDate = calendar.getNext(calendar.getToday(), 'd', 7);
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 7);
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];

    console.log(`this.currentDate,this.maxDate`, this.currentDate,this.maxDate);
  }

  ngOnInit(): void {
    this.selectedStatusValue = 25;

    this.omsServiceService.tenantOrgInfo$.subscribe(data => {
      console.log('tenats load for order', data)
      this.tenantOrgInfo = data
      if (!this.tenantOrgInfo) {
        this.dynamicSpan = 10
        this.tenantOrgInfo = [];
        console.log("tenantOrgInfo is empty")
      } else {
        this.dynamicSpan = 8
        console.log("tenantOrgInfo is loaded")
      }

      var uniqueTenants = [];
      var uniqueOrgs = [];
      this.tenantsList = [];
      this.OrgList = [];

      this.tenantOrgInfo.forEach((element, i) => {
        if (!uniqueTenants[this.tenantOrgInfo[i].tenantCode]) {
          this.tenantsList.push(this.tenantOrgInfo[i]);
          uniqueTenants[this.tenantOrgInfo[i].tenantCode] = 1;
        }
        if (!uniqueOrgs[this.tenantOrgInfo[i].orgCode]) {
          this.OrgList.push(this.tenantOrgInfo[i]);
          uniqueOrgs[this.tenantOrgInfo[i].orgCode] = 1;
        }
      });

      this.isAllOrderSearch = false;
      this.isTrack = false;
      this.totalRecords = 0;
      this.isOrderListDataExist = false;
      //console.log("role=" + window.localStorage.getItem('role'));
      //console.log("action By Id in ngonit=" + window.localStorage.getItem('actionById'));
      this.SpinnerService.show();
      if (window.localStorage.getItem('role') == "42") {
        this.isTrack = true;
      }
      this.configuraionData = configurton.filter(x => x.role == window.localStorage.getItem('role'));
      let selectedFromDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
      // let fromDateValue = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day)
      // let selectedFromDate = this.datePipe.transform(fromDateValue, 'yyyy-MM-dd');
      // let toDateValue = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day)
      // let selectedToDate = this.datePipe.transform(toDateValue, 'yyyy-MM-dd');
      
      //console.log(this.orderStatusList);
      //console.log("came");
      //console.log(this.sharedService.getActionById());

      this.sharedService.actionById.subscribe(val => {

        //console.log(val);
      });
      this.sharedService.sessionId.subscribe(val => {

        //  this.from = val;

      });
      this.sharedService.role.subscribe(val => {
        this.role = val;
        //this.role ="42";

      });
      this.sharedService.headerData.subscribe(val => {
        if (window.localStorage.getItem('role') != "" && window.localStorage.getItem('role') != undefined) {
          this.getOrderData(val, 1, false, 11);
          if (window.localStorage.getItem('role') == "42") {
            if (val == "0" || val == "26" || val == "25") //opd_c
              this.isAllOrderSearch = true;
            if (val == "26") {
               this.orderStatusList = this.configuraionData[0].header_unconfirmed_status;
              //this.orderStatusList =[];
              // this.orderStatusList = this.configuraionData[0].header_status;
              //this.orderStatusList = [{ name: "All", value: 26505 }, { name: "Slot Not Confirmed", value: 26 }, { name: "Payment NoT Confirmed", value: 505 }]
            }
            else {

              // this.orderStatusList = this.configuraionData[0].header_unconfirmed_status;
              this.orderStatusList = this.configuraionData[0].header_status;
            }

          }

          //this.getDiagnostiCenterData();
        }

      });

    }
    );

    //this.configuraionData =  configurton.filter(x=>x.role==this.role);

  }

  onTenantSelect() {
    let selectedTenant = this.searchForm.get('selectedTenant').value;
    var results = this.OrgList.filter(function (entry) {
      if (selectedTenant && selectedTenant.indexOf(entry.tenantCode) >= 0) {
        return true;
      }
    });
    this.organizationsOfTenants = results;
  }

  onTenantdeSelect(item) {
    let chnagedOrgs = [];

    if (this.searchForm.get('selectedOrg').value) {
      this.searchForm.get('selectedOrg').value.forEach(i => {
        console.log(i, item)
        if (i != item.orgCode)
          chnagedOrgs.push(i)
      })

      this.searchForm.patchValue({ 'selectedOrg': chnagedOrgs });
      console.log(chnagedOrgs)

    }
  }

  resetTeantFilters() {
    this.searchForm.patchValue({ 'selectedTenant': [], 'selectedOrg': [] });
    this.organizationsOfTenants = []
  }

  onOrgSelect() {
    let selectedTenant = this.searchForm.get('selectedTenant').value;
    let selectedOrg = this.searchForm.get('selectedOrg').value;
  }

  getTenantNameBycode(tenantCode) {
    let name = this.tenantsList.find(item => { return item.tenantCode == tenantCode });
    return name?.tenantName ? name.tenantName : '';
  }

  getOrgNameByCode(orgCode) {
    let name = this.OrgList.find(item => { return item.orgCode == orgCode });
    return name?.orgName ? name.orgName : "";
  }

  getOrderData(orderStatus, page = 1, pagination,type) {

    if (!pagination) {
      // this.searchForm.reset();
      let selectedFromDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      let selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
      this.selectedDate(selectedFromDate, selectedToDate);
      this.selectedDate(selectedFromDate, selectedToDate);
    }

    this.isAllOrderSearch = false;
    if (window.localStorage.getItem('role') == "42" && (orderStatus == "0" || orderStatus == 26)) {
      this.isAllOrderSearch = true;

    }
    //this.searchForm.patchValue({ 'startDate': this.fromDate, 'endDate': this.endDate });
    this.totalRecords = 0;
    this.SpinnerService.show();
    this.isOrderListDataExist = false;
    ////console.log(this.SpinnerService.show());
    this.orderRequest = this.prepareGetOrderDataRequest(orderStatus,type);
    this.orderDetailsRes = [];

    this.orderRequest['tenantCodes'] = [];
    this.orderRequest['orgCodes'] = [];

    // if(this.searchForm.get('selectedTenant').value){  //opd_c
    //   // if tenant org filters are used 
    //   this.orderRequest['tenantCodes']  = this.searchForm.get('selectedTenant').value;
    //   if(this.searchForm.get('selectedOrg')?.value)
    //     this.orderRequest['orgCodes']  = this.searchForm.get('selectedOrg').value;      

    // }else{       
    //   // by default we need to pass all tenat and org codes      
    //   this.tenantsList.map(item=>{
    //     this.orderRequest['tenantCodes'].push(item.tenantCode);
    //   });
    //   this.OrgList.map(item=>{ 
    //     this.orderRequest['orgCodes'].push(item.orgCode);
    //   });
    // } 
    this.orderRequest['skipTenantValidation'] = 1;


    this.omsServiceService.getOrderDetails(this.orderRequest).subscribe(
      (res) => {
        this.SpinnerService.hide();
        if (res["status"] == 1) {
          this.orderDetailsRes = res["data"][0]["orderDetails"];
          if (res["data"][0]["countOrder"][0] != null) {

            this.datacount = res["data"][0]["countOrder"][0]["count"];
            this.totalRecords = this.datacount;
            if(type == 11){
              this.page=1
            }
            //this.isOrderListDataExist =true;
            //console.log(configurton);
            this.configuraionData = configurton.filter(x => x.role == this.role);
            //console.log(this.configuraionData);
            // this.configuraionData[0].isUCdOrder
            this.SpinnerService.hide();
          } else {
            this.isOrderListDataExist = true;
            this.datacount = 0;
          }

        } else {
          this.SpinnerService.hide();
          this.datacount = 0;
        }

      }

    )
  }

  getOrderById(orderId) {
    this.SpinnerService.hide();
        // this.SpinnerService.show();
    let sessionId;
    this.sharedService.sessionId.subscribe(val => {
      sessionId = val;
      //this.role ="42";

    });
    // window.open(this._router.navigate(['/order-details/' + orderId], { queryParams: { session: sessionId } }).toString(), '_blank');

    // this._router.navigate(["order-details/"+orderId]", [queryParams]=" {session: 'session'}"]);
    // this._router.navigate(['/order-details/' + orderId], { queryParams: { session: sessionId } });

    const url=this._router.createUrlTree(['/order-details/' + orderId])
    // const url=this._router.createUrlTree(['/opdexecution/' + '/order-details/' + orderId], { queryParams: { session: sessionId } })
    window.open(url.toString(),'_blank')
  }


  pageChange(currentPage) {
    console.log(`currentPage`, currentPage);
    if (this.searchForm.get('status').value != 0 && this.searchForm.get('status').value != undefined) {
      let status = this.searchForm.get('status').value
      this.getOrderData(status, currentPage, true, 22);
    }else{
      let selectedStatus;
      this.sharedService.headerSelectedStatus.subscribe(val => {
        //console.log("select status value=" + val);
        selectedStatus = val;
      });
      this.getOrderData(selectedStatus, currentPage, true, 22);
    }
  }

  search(searchFormData, page = 1) {
    this.totalRecords = 0;
    this.isOrderListDataExist = false;
    this.orderDetailsRes = [];
    //if (this.searchForm.valid) {
    this.SpinnerService.show();
    this.searchFormRequest = {};
    // let fromDate = this.fromDate;
    let fromDate = this.currentDate
    let selectedStatus;
    this.sharedService.headerSelectedStatus.subscribe(val => {

      console.log("select status value=" + val);
      selectedStatus = val;
      if (val == 0 || val == 26) {
        selectedStatus = 25; //opd_c
      }

    });
    let selectedFromDate;
    let selectedToDate;
    if (fromDate != null && fromDate != undefined ) {
      // let fromDateValue = fromDate.year + "-" + fromDate.month + "-" + fromDate.day;
      let fromDateValue = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
      selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));
    } else {

      let fromDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() - 2) + "-" + new Date().getDate();

    }
    // let toDate = this.toDate;
    let toDate = this.maxDate;
    if (toDate != null && toDate != undefined ) {
      // let toDateValue = toDate.year + "-" + toDate.month + "-" + toDate.day;
      let toDateValue = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
      selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    } else {

      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      ;

    }
    this.searchFormRequest["actionById"] = window.localStorage.getItem('actionById');;
    // this.searchFormRequest["businessId"] = this.constantsService.BUSINESS_ID; //opd_c
    // this.searchFormRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    this.searchFormRequest["dateFilter"] = this.constantsService.DATE_FILTER;

    this.searchFormRequest["action"] = this.constantsService.ORDER_LIST_METHOD;
    this.searchFormRequest["type"] = this.constantsService.METHOD_TYPE;
    let searchStatus: boolean = false;

    if (this.searchForm.get("searchByValue").value != null && this.searchForm.get("searchByValue").value != undefined) {
      // searchStatus = true;
      if (this.searchForm.get("searchBy").value == "MRN") {
        this.searchFormRequest["mrn"] = this.searchForm.get("searchByValue").value;
      }
      else if (this.searchForm.get("searchBy").value == "Order ID") {
        this.searchFormRequest["order_id"] = this.searchForm.get("searchByValue").value;
      }
      else if (this.searchForm.get("searchBy").value == "Order Did") {
        this.searchFormRequest["order_did"] = this.searchForm.get("searchByValue").value;
      }

    } else {
      this.searchFormRequest["startDate"] = selectedFromDate;
      this.searchFormRequest["endDate"] = selectedToDate;
    }
    if(this.searchForm.get("sortBy").value != null && this.searchForm.get("sortBy").value != undefined){
      if (this.searchForm.get("sortBy").value == "Scheduled Date") {
        this.searchFormRequest["dateFilter"] = "scheduled_date";
      }
      else if (this.searchForm.get("sortBy").value == "Created Date") {
        this.searchFormRequest["dateFilter"] = "created_date";
      }
    }
    this.searchFormRequest['skipTenantValidation'] = 1;

console.log('order status ='+status)
    //status search begins
    if (this.searchForm.get("searchByValue").value == null && this.searchForm.get("searchByValue").value == undefined) {
      if (searchFormData.controls.status.value != 0 && searchFormData.controls.status.value != undefined) {
        let status = searchFormData.controls.status.value;
        if (status == 26 || status == 25) {
          this.searchFormRequest["orderStatus"] = [status, 505, 1000, 1001];
        } else if (status == 1001) {
          this.searchFormRequest["orderStatus"] = [status, 300];
        }else if(status == 2){
          this.searchFormRequest["orderStatus"] = [status,1,21,24,7];
        }else if(status == 301){
          this.searchFormRequest["orderStatus"] = [status,902,302,303];
        }else {
          this.searchFormRequest["orderStatus"] = [status];
        }
        // if (status == 3) {
        //   this.searchFormRequest["orderStatus"] = [25, 26, 505];
        // }
        // else if (status == 1001) {
        //   this.searchFormRequest["orderStatus"] = [status, 300];
        // }
        // else {

        //   this.searchFormRequest["orderStatus"] = [status];
        // }

        if (window.localStorage.getItem('role') == "42" && selectedStatus == 26 && status != 3) {
          this.searchFormRequest["orderStatus"] = [status];
        }

        if (window.localStorage.getItem('role') == "42" && selectedStatus == 23 && status != 3) {
          this.searchFormRequest["orderStatus"] = [status];
        }

      }else{

        this.searchFormRequest["orderStatus"] = [25, 505, 1000, 1001];

      }

    }

console.log('getting order status 1='+this.searchFormRequest["orderStatus"])

    if (this.configuraionData[0].allowedStatus != undefined && this.configuraionData[0].allowedStatus.indexOf(-1) < 0) {
      if (selectedStatus == 0)
        this.searchFormRequest["orderStatus"] = this.configuraionData[0].allowedStatus;
      else
        this.searchFormRequest["orderStatus"] = [selectedStatus];

    }
console.log('getting order status 2='+this.searchFormRequest["orderStatus"])
    // if (this.searchFormRequest["orderStatus"] != "" && this.searchFormRequest["orderStatus"] != undefined && this.searchFormRequest["orderStatus"].indexOf(selectedStatus) < 0 && selectedStatus != 0 && selectedStatus != 26) {
    //   this.searchFormRequest["orderStatus"] = this.searchFormRequest["orderStatus"].concat(selectedStatus);
    // }
console.log('getting order status 3='+this.searchFormRequest["orderStatus"])
    if (window.localStorage.getItem('role') == "26") {


      this.searchFormRequest["associateId"] = window.localStorage.getItem('associateId');
      this.searchFormRequest["associateBranchId"] = window.localStorage.getItem('branchId');
    } else if (window.localStorage.getItem('role') == "42") {
      this.searchFormRequest["corporateType"] = "chopd"; //opd_c
      // this.searchFormRequest["AssigneeID"] = window.localStorage.getItem('actionById'); //opd_c

      // if (selectedStatus != 0 && !searchStatus && selectedStatus != 26) {
      //   // this.searchFormRequest["orderStatus"] = [selectedStatus];
      //   if (this.searchFormRequest["orderStatus"] != "" && this.searchFormRequest["orderStatus"] != undefined) {
      //     this.searchFormRequest["orderStatus"] = this.searchFormRequest["orderStatus"].concat(selectedStatus);
      //   }else if(selectedStatus == 25){
      //     this.searchFormRequest["orderStatus"] = [selectedStatus, 505, 1000, 1001];
      //   }else if(selectedStatus == 2){
      //     this.searchFormRequest["orderStatus"] = [selectedStatus, 1, 21, 24, 7];
      //   }else if(selectedStatus == 301){
      //     this.searchFormRequest["orderStatus"] = [selectedStatus, 902, 302, 303];
      //   }else {
      //     this.searchFormRequest["orderStatus"] = [selectedStatus, 505, 1000, 1001];
      //   }
      // }
console.log('getting order status 4='+this.searchFormRequest["orderStatus"])
      //  if(window.localStorage.getItem('role') == "42" && selectedStatus ==26)
      //  {
      //   this.searchFormRequest["orderStatus"] = [selectedStatus, 505];
      //  }

    }

  if(this.searchFormRequest["orderStatus"] == "8"){
    this.searchFormRequest["orderStatus"] = [8,15];
  }

console.log('getting order status 5='+this.searchFormRequest["orderStatus"])

    if (this.pageSize != 0 && this.page != 0) {
      this.searchFormRequest["sortBy"] = this.constantsService.SORT_BY;
      this.searchFormRequest["limit"] = this.pageSize;;
      // this.searchFormRequest["skip"] = this.pageSize * (this.page - 1);
      this.searchFormRequest["skip"] = 0;
    }


    this.searchFormRequest['tenantCodes'] = [];
    this.searchFormRequest['orgCodes'] = [];

    if (this.searchForm.get('selectedTenant').value) {
      // if tenant org filters are used 
      this.searchFormRequest['tenantCodes'] = this.searchForm.get('selectedTenant').value;
      if (this.searchForm.get('selectedOrg').value)
        this.searchFormRequest['orgCodes'] = this.searchForm.get('selectedOrg').value;


    } else {
      // by default we need to pass all tenat and org codes      
      this.tenantsList.map(item => {
        this.searchFormRequest['tenantCodes'].push(item.tenantCode);
      });
      this.OrgList.map(item => {
        this.searchFormRequest['orgCodes'].push(item.orgCode);
      });
    }

    if(this.searchForm.get("businessId").value != null && this.searchForm.get("businessId").value != undefined){    
        this.searchFormRequest["businessId"] = [this.searchForm.get("businessId").value];
    }
    console.log('tenant', this.searchFormRequest['tenantCodes'])
    console.log('org', this.searchFormRequest['orgCodes'])
    console.log('sortBy', this.searchForm.get("sortBy").value)
    console.log('businessId', this.searchForm.get("businessId").value)

    // this.searchFormRequest["mode_of_service"] = 2;

    this.omsServiceService.getOrderDetails(this.searchFormRequest).subscribe(
      (res) => {
        this.orderDetailsRes = res["data"][0]["orderDetails"];
        this.searchFormRequest = {};
        //this.searchForm.reset();
        if (res["data"][0]["countOrder"][0] != null) {
          this.datacount = res["data"][0]["countOrder"][0]["count"];
          this.totalRecords = this.datacount;
          this.page =1;
          //this.SpinnerService.hide();
        } else {
          this.isOrderListDataExist = true;
          this.datacount = 0;
        }
        this.SpinnerService.hide();
      }

    )
    //}
    this.SpinnerService.hide();
  }


  getDate(val: any) {

    let dateEntered = val.target.value;

  }
  verifyOtpRequestInfo(obj, id) {

    let otp = (<HTMLInputElement>document.getElementById('verifyOtp' + id)).value;

    let verifyOtpInfoRequest = {};
    verifyOtpInfoRequest["method"] = this.constantsService.OTP_VERIFY_METHOD;
    verifyOtpInfoRequest["type"] = this.constantsService.METHOD_TYPE;

    // verifyOtpInfoRequest["mobile"] = 9618979187;
    verifyOtpInfoRequest["mobile"] = obj.order.patientinfo.contact;
    verifyOtpInfoRequest["email"] = obj.order.patientinfo.email;
    verifyOtpInfoRequest["keyValue"] = "MHO00213";
    verifyOtpInfoRequest["keyType"] = "ISP";
    verifyOtpInfoRequest["sourceType"] = "Mobile-APP";
    verifyOtpInfoRequest["otp"] = otp;


    this.omsServiceService.sendOtp(verifyOtpInfoRequest).subscribe(
      (res) => {

        //this.otpResponse = res["status"];
        this.isOtpSend = true;
        if (res["status"] == 1) {
          this.confirmOrder(obj);
        }

      }
    )
  }
  confirmOrder(obj) {

    let orderConfirmationRequest = {};

    // orderConfirmationRequest["method"] = "OMS/api/operation.php/v1/change/order/status";
    //orderConfirmationRequest["type"] = "POST";
    orderConfirmationRequest["order_id"] = [obj.order.patientinfo.order_id];
    orderConfirmationRequest["actionById"] = window.localStorage.getItem('actionById');;
    orderConfirmationRequest["actionByName"] = "UAT Madinaguda";
    orderConfirmationRequest["source"] = "1";
    // orderConfirmationRequest["comment"] = "Order confirmation";
    orderConfirmationRequest["reason"] = "";

    orderConfirmationRequest["role_id"] = this.constantsService.ROLE_ID;
    orderConfirmationRequest["status"] = 301;
    orderConfirmationRequest["type"] = "post";
    orderConfirmationRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    // orderConfirmationRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    this.omsServiceService.orderConfirmation(orderConfirmationRequest).subscribe(
      (res) => {
        //console.log(res);
        //this.confirmOrderResponse = res.message;
        //this.isConfirmedOrder = true;

      });

  }

  prepareGetOrderDataRequest(orderStatus,type) {
    //orderStatus = orderStatus.replace(/"/g,"");
    orderStatus = Number(orderStatus);
    this.orderRequest = {};
    //  this.orderRequest["actionById"] = this.constantsService.ACTION_BY_ID;
    this.orderRequest["actionById"] = window.localStorage.getItem('actionById');

    // this.orderRequest["businessId"] = this.constantsService.BUSINESS_ID; //opd_c
    // this.orderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;

    // this.orderRequest["mode_of_service"] = 2;

    this.orderRequest["dateFilter"] = this.constantsService.DATE_FILTER;
    //this.orderRequest["endDate"] = "2020-12-05";
    //this.orderRequest["startDate"] = "2020-10-02";

    //let selectedFromDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
    //let selectedFromDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
    let fromDateValue = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate();
    // selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));
    // let fromDate = this.fromDate
    let fromDate = this.currentDate
    // selectedFromDate = "2021-01-01";
    let selectedFromDate;
    if (fromDate != null && fromDate != undefined ) {
      // let fromDateValue = fromDate.year + "-" + fromDate.month + "-" + fromDate.day;
      let fromDateValue = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
      selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));

    }

    this.orderRequest["startDate"] = selectedFromDate;
    let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 2) + "-" + new Date().getDate();
    // let selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    let selectedToDate;
    // let toDate = this.toDate;
    let toDate = this.maxDate;
    if (toDate != null && toDate != undefined ) {
      // let toDateValue = toDate.year + "-" + toDate.month + "-" + toDate.day;
      let toDateValue = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
      selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    }
    this.orderRequest["endDate"] = selectedToDate;
    this.orderRequest["action"] = this.constantsService.ORDER_LIST_METHOD;
    this.orderRequest["type"] = this.constantsService.METHOD_TYPE;

    // this.orderRequest["startDate"] = this.selectedFromDate;
    // this.orderRequest["endDate"] = this.selectedToDate;
    //this.selectedDate(selectedFromDate,selectedToDate);
    if (orderStatus == 1001) {
      //this.orderRequest["isUCDOrder"] = this.constantsService.IS_UCD_ORDER;
      //this.orderRequest["isUCDOrder"] = 1;
    }
    // if (this.searchForm.get("searchByValue").value != null && this.searchForm.get("searchByValue").value != undefined) {
    //   this.orderRequest["mrn"] = this.searchForm.get("searchByValue").value;
    // }

    // if (this.pageSize != 0 && this.page != 0) {
    //   this.orderRequest["sortBy"] = this.constantsService.SORT_BY;
    //   this.orderRequest["limit"] = this.pageSize;
    //   this.orderRequest["skip"] = this.pageSize * (this.page - 1);
    // }
     if (this.pageSize != 0 && this.page != 0 && type == 22) {
      this.orderRequest["sortBy"] = this.constantsService.SORT_BY;
      this.orderRequest["limit"] = this.pageSize;
      this.orderRequest["skip"] = this.pageSize * (this.page - 1);
    }else{
      this.orderRequest["sortBy"] = this.constantsService.SORT_BY;
      this.orderRequest["limit"] = this.pageSize;
      this.orderRequest["skip"] = 0;
    }


    if (orderStatus > 0) {

      if (orderStatus == 26 || orderStatus == 25) {
        this.orderRequest["orderStatus"] = [orderStatus, 505, 1000, 1001];
      } else if (orderStatus == 1001) {
        this.orderRequest["orderStatus"] = [orderStatus, 300];
      }else if(orderStatus == 2){
        this.orderRequest["orderStatus"] = [orderStatus,1,21,24,7];
      }else if(orderStatus == 301){
        this.orderRequest["orderStatus"] = [orderStatus,902,302,303];
      }
      else {
        this.orderRequest["orderStatus"] = [orderStatus];
      }

    }

    //  if(orderStatus ==301)
    //  {
    //   this.orderRequest["orderStatus"] = [orderStatus,2];
    //  }
    //  if(orderStatus ==26505)
    //  {
    //   this.orderRequest["orderStatus"] = [26,505];
    //  }

    //console.log("this.constantsService.ROLE_ID=" + this.constantsService.ROLE_ID);
    if (window.localStorage.getItem('role') == "26") {
      // this.orderRequest["associateId"] = this.constantsService.LOGIN_ASSOCIATE_ID;
      //this.orderRequest["associateBranchId"] = this.constantsService.LOGIN_ASSOCIATE_BRANCH_ID;
      this.orderRequest["associateId"] = window.localStorage.getItem('associateId');
      this.orderRequest["associateBranchId"] = window.localStorage.getItem('branchId');
      //branchId

    } else if (window.localStorage.getItem('role') == "42") {
      //console.log("role in 42=" + this.constantsService.ROLE_ID);
      //console.log("action ById=" + this.constantsService.ACTION_BY_ID);
      //this.orderRequest["AssigneeID"] = this.constantsService.ACTION_BY_ID;
      this.orderRequest["corporateType"] = 'chopd'; //opd_c
      // this.orderRequest["AssigneeID"] = window.localStorage.getItem('actionById'); //opd_c
    }
    if ((this.orderRequest["orderStatus"] == "" || this.orderRequest["orderStatus"] == undefined) && this.configuraionData[0].allowedStatus != undefined && this.configuraionData[0].allowedStatus.indexOf(-1) < 0) {
      //&& this.configuraionData[0].allowedStatus.
      this.orderRequest["orderStatus"] = this.configuraionData[0].allowedStatus;
    }
    if(this.searchForm.get("businessId").value != null && this.searchForm.get("businessId").value != undefined){
      this.orderRequest["businessId"] = [this.searchForm.get("businessId").value];
    }

  //  if (this.searchForm.get("status").value != 0 && this.searchForm.get("status").value != undefined) {
  //   let status = this.searchForm.get("status").value;
  //     this.orderRequest["orderStatus"] = [status];
  //  } 

  if (this.searchForm.get("searchByValue").value != null && this.searchForm.get("searchByValue").value != undefined) {
    // searchStatus = true;
    if (this.searchForm.get("searchBy").value == "MRN") {
      this.orderRequest["mrn"] = this.searchForm.get("searchByValue").value;
    }
    else if (this.searchForm.get("searchBy").value == "Order ID") {
      this.orderRequest["order_id"] = this.searchForm.get("searchByValue").value;
    }
    else if (this.searchForm.get("searchBy").value == "Order Did") {
      this.orderRequest["order_did"] = this.searchForm.get("searchByValue").value;
    }
  }

    return this.orderRequest;

  }

  loadReports(order) {

    // //console.log("load");
    const modalRef = this.modalService.open(ReportDetailsComponent);
    modalRef.componentInstance.reportDocInfo = order;
    const closeModelRef = modalRef.result.then(
      (res) => {

        //this.getOrderDataById(this.id);

      }

    );
  }

  //   openUploadReportItemModal(orderObj) {
  //     //console.log("report upload called");
  //     //console.log(orderObj);
  //     const modalRef = this.modalService.open(UploadReportComponent);

  //     const closeModelRef = modalRef.result.then(
  //       (res) => {
  // //console.log(res);
  //        // this.getOrderDataById(this.id);

  //       }

  //     );

  //     modalRef.componentInstance.order_id = orderObj._id;

  //   }

  getDiagnostiCenterData() {

    let diagnosticCenterApi = {};
    diagnosticCenterApi["business_id"] = "3";
    diagnosticCenterApi["name"] = "test";
    diagnosticCenterApi["limit"] = 1000;
    diagnosticCenterApi["offset"] = 0;


    this.omsServiceService.getDiagnosticData(diagnosticCenterApi).subscribe(

      (res) => {
        if (res["status"] == "Success") {
          if (res["dataObject"] != null && res["dataObject"] != undefined) {
            for (let data of res["dataObject"]) {
              //console.log(data.code);
              //console.log(data.name);
              this.diagnosticCenterList.push({ "code": data.code, name: data.name });
            }
          }

        }
        //console.log(this.diagnosticCenterList);


        //  this.diagnosticCenterList.push({"id":"",name:""});
      }

    )
  }

  clear() {


    //this.searchByValue = "": 
    //console.log("clear");
    this.searchForm.reset();
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];
    this.currentDate=new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];

    // this.searchForm.

  }

  trackOrder(orderId) {


  }


  opentrackOrderModal(orderId) {
    //console.log(this.orderDetailsRes);
    const modalRef = this.modalService.open(TrackOrderComponent, { windowClass: 'commonStyleModals modalWidth90p' });
    const closeModelRef = modalRef.result.then(
      (res) => {

        //this.getOrderDataById(this.id);

      }

    );

    modalRef.componentInstance.order_id = orderId;


  }

  onValueChange(value: Date): void {
    var data = value;
    this.currentDate=data[0]
    this.maxDate=data[1]
    console.log(`data`, this.currentDate);
  }

  selectedDate(fromDate, endDate) {
    if (fromDate) {
      const [year, month, day] = fromDate.split('-');
      const obj = {
        year: parseInt(year), month: parseInt(month), day:
          parseInt(day.split(' ')[0].trim())
      };
      // this.fromDate = obj;
    }

    if (endDate) {
      const [year, month, day] = endDate.split('-');
      const obj = {
        year: parseInt(year), month: parseInt(month), day:
          parseInt(day.split(' ')[0].trim())
      };
      // this.endDate = obj;
    }

    //this.searchForm.setValue({ 'searchBy': '', 'diagnosticBranch':'','searchByValue': '', 'startDate': this.fromDate, 'endDate': this.endDate,'status':'' });
    this.searchForm.patchValue({ 'startDate': this.fromDate, 'endDate': this.endDate });
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

}
